/**
 * Staff Users Hook — fetches ATEK staff from /v4/users for name lookups
 */

import { useQuery } from '@tanstack/react-query';
import { fetchStaffUsers } from '../api';
import type { StaffUser } from '../types';

export const staffUsersKeys = {
  all: ['meetings-staff-users'] as const,
};

export function useStaffUsers() {
  return useQuery({
    queryKey: staffUsersKeys.all,
    queryFn: fetchStaffUsers,
    staleTime: 10 * 60 * 1000, // 10 min — staff list changes rarely
  });
}

export function useStaffUserMap(): Map<string, StaffUser> {
  const { data = [] } = useStaffUsers();
  return new Map(data.map((u) => [u.id, u]));
}
